// Angular
import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

// NGRX
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, filter, map, catchError } from 'rxjs/operators';

// OLCI
import * as olci from '../actions';
import * as fromRoot from '../reducers';
import { constants } from '../constants';
import { ContractsService } from '../modules/core/services/contracts.service';

export const travelQuestionnaireResolver: ResolveFn<any> = (): Observable<any> | any => {
    const contractsService: ContractsService = inject(ContractsService);
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
    const router: Router = inject(Router);

    if (!contractsService.areTravelQuestionnairesInTheStore) {
        const payload = contractsService.getTravelQuestionnairePayload();
        if(!(payload?.authorizedConsents?.length)){
            router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
            return of(false);
        }
        store.dispatch(new olci.LoadTravelQuestionnaireAction(payload));
    }

    return store.pipe(
        select(fromRoot.getCruiseContractState),
        filter(cruiseContractState => cruiseContractState.loadingQuestionnaire === false || cruiseContractState.error),
        take(1),
        map(res => {
            if (res.error) {
                throw res.error;
            }
            return res;
        }),
        catchError(error => {
            store.dispatch(new olci.NavigateToError());
            return of(false);
        })
    );
}
